import {
  clientAddressIsPrimary,
  ClientEntity
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {PrimaryClientAddress} from "./PrimaryClientAddress";
import {toPrimaryClientAddress} from "./toPrimaryClientAddress";

/**
 * The {@link primaryAddressesFromClientEntity} examines the addresses of
 * a given {@link ClientEntity} retaining only those that are flagged as
 * primary and mapping each {@link ClientAddress} into a
 * {@link PrimaryClientAddress} for use in the UI.
 *
 * @param client The {@link ClientEntity} whose addresses are to be examined.
 *
 * @see {@link clientAddressIsPrimary}
 * @see {@link toPrimaryClientAddress}
 */
export const primaryAddressesFromClientEntity = (
  client: ClientEntity
): PrimaryClientAddress[] =>
  client.addresses
    ?.filter(clientAddressIsPrimary)
    .map(toPrimaryClientAddress(client)) || [];
